import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { salonInfo } from '../data/mock';
import { useLanguage } from '../i18n/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-neutral-950 text-neutral-300 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-20">
        <div className="grid md:grid-cols-12 gap-12 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <img
              src="/assets/logo-brand.png"
              alt="Unnie Korean Skincare Revolution"
              className="h-16 md:h-20 w-auto mb-8"
            />
            <p className="text-neutral-400 leading-relaxed font-light max-w-sm mb-8">
              {t.footer.tagline}
            </p>
            <div className="flex gap-3">
              <a
                href={salonInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-white/15 hover:border-lilac hover:text-lilac rounded-full flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                href="#"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-white/15 hover:border-lilac hover:text-lilac rounded-full flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Kontakt */}
          <div className="md:col-span-3">
            <p className="eyebrow text-sage mb-6">{t.footer.contact}</p>
            <div className="space-y-3 text-sm font-light">
              <p className="text-neutral-400">{salonInfo.address}</p>
              <a
                href={`tel:${salonInfo.phone.replace(/\s/g, '')}`}
                className="block text-neutral-300 hover:text-lilac transition-colors"
              >
                {salonInfo.phone}
              </a>
              <a
                href={`mailto:${salonInfo.email}`}
                className="block text-neutral-300 hover:text-lilac transition-colors break-all"
              >
                {salonInfo.email}
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="md:col-span-4">
            <p className="eyebrow text-sage mb-6">{t.footer.hours}</p>
            <div className="space-y-3 text-sm font-light">
              <div className="flex justify-between border-b border-white/5 pb-2">
                <span className="text-neutral-500">{t.footer.weekdays}</span>
                <span className="text-neutral-200">{salonInfo.hours.weekdays}</span>
              </div>
              <div className="flex justify-between border-b border-white/5 pb-2">
                <span className="text-neutral-500">{t.footer.saturday}</span>
                <span className="text-neutral-200">{salonInfo.hours.saturday}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-neutral-500">{t.footer.sunday}</span>
                <span className="text-neutral-400">{t.footer.sundayClosed}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4">
          <p className="eyebrow text-neutral-600">
            © {new Date().getFullYear()} Unnie · Korean Skincare Revolution
          </p>
          <p className="eyebrow text-neutral-600">{t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
